//AJAX 프레임
import { ajaxFrame } from '../lib/ajaxForm';
//데이터 API 목록
import { dataUrl } from '../dataUrl';
//로딩 액션
import { AjaxLoading } from '../../../actions/Interactions/loading';
//쿠키 호출
import { cookies } from '../lib/cookies';

//쿠키 시간 설정
export const sessionTime = 3;
export const loginFunc = {
	memberLogIn:function(data) {
		var userId = data[0].value;
		var userPw = data[1].value;
		var param = '?user_name=' + userId + '&pwd=' + userPw + '&service_type=basic';
		var dataApi = dataUrl.alwaysAPI('POST','login', param);
		ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, loginFunc.loginCallBack);
	},
	loginCallBack:function(data) {
		var data = data.data;
		var userDataArray = [data.token,data.user_id,data.user_name,data.name];
		var userKeyArray = ['token','user_id','user_name','user_nm'];
		var homeUrl = document.location.hostname;
		var moveHome = 'http://' + homeUrl;
		var urlPort = window.location.port;
		for(var i = 0; i < userKeyArray.length; i ++) {
			if(userKeyArray[i] == 'user_nm'){
				var temp_key = userKeyArray[i];
				var temp_value =  loginFunc.encodeURL(userDataArray[i]);
				cookies.setCookies(temp_key, temp_value , sessionTime);

			}else{
				cookies.setCookies(userKeyArray[i],userDataArray[i], sessionTime);
			}

		}
		if(urlPort != '') {
			moveHome = moveHome + ":" + urlPort ;
		}
		location.href = moveHome;

	},
	memberLogOut:function() {
		var userKeyArray = ['token','user_id','user_name','user_nm'];
		for(var i = 0; i < userKeyArray.length; i++) {
			var userCheck = cookies.getCookies(userKeyArray[i]);
			cookies.setCookies(userKeyArray[i], userCheck, -sessionTime);
		}
		$("input[type='hidden']").val('');
		location.href = '#/member/login';
	},
	encodeURL:function(str){
		var s0, i, s, u;
		s0 = "";                // encoded str
		for (i = 0; i < str.length; i++){   // scan the source
			s = str.charAt(i);
			u = str.charCodeAt(i);          // get unicode of the char
			if (s == " "){
				s0 += "+"; // SP should be converted to "+"
			}else{
				if ( u == 0x2a || u == 0x2d || u == 0x2e || u == 0x5f || ((u >= 0x30) && (u <= 0x39)) || ((u >= 0x41) && (u <= 0x5a)) || ((u >= 0x61) && (u <= 0x7a))){       // check for escape
				s0 = s0 + s; // don't escape
				}else { // escape
					if ((u >= 0x0) && (u <= 0x7f)){     // single byte format
						s = "0"+u.toString(16);
						s0 += "%"+ s.substr(s.length-2);
					}else if (u > 0x1fffff){     // quaternary byte format (extended)
						s0 += "%" + (oxf0 + ((u & 0x1c0000) >> 18)).toString(16);
						s0 += "%" + (0x80 + ((u & 0x3f000) >> 12)).toString(16);
						s0 += "%" + (0x80 + ((u & 0xfc0) >> 6)).toString(16);
						s0 += "%" + (0x80 + (u & 0x3f)).toString(16);
					}else if (u > 0x7ff){        // triple byte format
						s0 += "%" + (0xe0 + ((u & 0xf000) >> 12)).toString(16);
						s0 += "%" + (0x80 + ((u & 0xfc0) >> 6)).toString(16);
						s0 += "%" + (0x80 + (u & 0x3f)).toString(16);
					}else {                      // double byte format
						s0 += "%" + (0xc0 + ((u & 0x7c0) >> 6)).toString(16);
						s0 += "%" + (0x80 + (u & 0x3f)).toString(16);
					}
				}
			}
		}
		return s0;
	}

}

window.sessionTime = sessionTime;
window.loginFunc = loginFunc;



// WEBPACK FOOTER //
// ./js/controller/assets/member/loginFunc.js